/* eslint-disable no-prototype-builtins */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';		// takeUntil, map, tap, catchError, first
import { Title } from '@angular/platform-browser';
import WebFont from 'webfontloader';


import { UsrPwd } from "../../../modulo-comunes/interfaces/user-interfaces";
import { AngularFireFunctions } from '@angular/fire/functions';
import { FireUserService } from "../../../modulo-comunes/servicios/fire-user-servicios";
import { FireEmpresaService } from "../../../modulo-comunes/servicios/fire-empresa-servicios";
import { DataArbitroService } from "../../../modulo-comunes/servicios/data-arbitro-servicios";
import { FireArbitroService } from "../../../modulo-comunes/servicios/fire-arbitro-servicios";
import { DataUserService } from "../../../modulo-comunes/servicios/data-user-servicios";
import { DataEmpresaService } from "../../../modulo-comunes/servicios/data-empresa-servicios";
import { DataSubscriptionService } from "../../../modulo-comunes/servicios/data-subscription-servicios";
import { FireConfigService } from "../../../modulo-comunes/servicios/fire-config-servicios";
import { DataConfigService } from "../../../modulo-comunes/servicios/data-config-servicios";
import { FuncionesService } from "../../../modulo-comunes/servicios/funciones-servicios";
import { FechaHoraService } from "../../../modulo-comunes/servicios/fechahora-servicios";
import { MuestraService } from "../../../modulo-comunes/servicios/muestra-servicios";
import { LogService } from "../../../modulo-comunes/servicios/log-servicios";
import { userAutVacio, userVacio } from "../../../modulo-comunes/datos/user-data";

@Component({
  selector: 'app-ingreso',
  templateUrl: './ingreso.component.html',
  styleUrls: ['./ingreso.component.css']
})
export class IngresoComponent implements OnInit, OnDestroy {
  private _onDestroy$: Subject<void> = new Subject();
  superUser: boolean = false;

  formIngreso = this.fb.group({
    //El usr va a ser un e-mail, no un texto cualquiera
    //fTxtUsr: ["", [Validators.required, Validators.minLength(5)]],
    fTxtMail: ["", [Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-]{2,8}$")]],
    fTxtPwd: ["", [Validators.required, Validators.minLength(8)]]
  });
  modeloUsrPwd: UsrPwd;
  modeloUsrPwdAnt = {}; //para evitar que presionen Cotizar varias veces y se multiplique la misma cotización
  modeloUsrPwdNue = {};
  //anteriorUsrPwd;
  //En este programa voy a usar la técnica del form, no la del modelo. Para no causar confusión, la fuente real de 
  //los datos del form va a ser formIngreso, pero voy a usar modeloLogin para guardar los datos como variables. 
  modeloLogin = {
    mail: '',
    pwd: '',
    mailReg: '',
    pwdReg1: '',
    pwdReg2: '',
    userYaCargado: this.dataUserService.userYaCargado,
    empresa: ''
  };
  mensajeLogin: string = '';
  mensajeLogin2: string = '';
  mensajeRegistro: string = '';
  mensajeRegistro2: string = '';

  yaLogin = false;
  formOk = false;
  formError = false;
  formDuplic = false;
  srcLogo: string;
  sitio: string;

  empAutElegida: string;
  empAutElegidaPrefijo: string;
  rutaEmpresaElegida: string;


  constructor(
    private fireFunc: AngularFireFunctions,
    private fb: FormBuilder,
    private router: Router,
    private titleService: Title,
    private fireUserService: FireUserService,
    private dataUserService: DataUserService,
    private fireConfigService: FireConfigService,
    private fireArbitroService: FireArbitroService,
    public dataArbitroService: DataArbitroService,
    public dataConfigService: DataConfigService,
    private dataSubscriptionService: DataSubscriptionService,
    private funcionesService: FuncionesService,
    private fechaHoraService: FechaHoraService,
    private muestraService: MuestraService,
    private logService: LogService,
    public dataEmpresaService: DataEmpresaService,
    private fireEmpresaService: FireEmpresaService
  ) {
  }

  ngOnInit() {

    // cargar la fuente de Google
    WebFont.load({ google: { families: ["Exo:100,100italic,200,200italic,300,300italic,400,400italic,500,500italic,600,600italic,700,700italic,800,800italic,900,900italic"] } });
    this.sitio = this.dataEmpresaService.sitioElegido;
    this.titleService.setTitle(this.sitio);

    this.logService.consoleLog('4', 'Ingreso a ' + this.sitio);
    if (this.sitio == 'EasyMed') {
      this.srcLogo = "assets/images/EMlogo2.svg";
    } else if (this.sitio == 'Efisys') {
      this.srcLogo = "assets/images/logo-efisys2.svg";
    }

    this.ocultaTopBar();
    this.ocultaFooter();
    this.modeloLogin.mail = '';
    this.modeloLogin.pwd = '';
    this.logService.consoleLog('2', "PC IN userYaCargado: " + this.dataUserService.userYaCargado);
    this.logService.consoleLog('2', "PC IN user: " + this.dataUserService.user.nombre);
    this.logService.consoleLog('2', "PC IN userAut: " + this.dataUserService.userAut.nombre);
    if (this.dataUserService.userYaCargado) {
      this.logout('Ya estaba cargado un usuario');
    }

  }

  ngOnDestroy(): void {
    //Esta técnica de this._onDestroy$ en ngOnDestroy
    //permite liberar todos los Observables que tengan un .takeUntil(this._onDestroy$)
    //Si un Observable tiene take(n) no requiere destruirse porque ya lo hace luego de leer n veces
    this._onDestroy$.next();
    this._onDestroy$.complete();
    this.muestraTopBar();
    this.muestraFooter();
  }

  public findInvalidControls(f: FormGroup): string[] {
    return this.funcionesService.findInvalidControls(f);
  }

  public chkValido(f: FormGroup, nombre: string): boolean {
    return this.funcionesService.chkValido(f, nombre);
  }

  public asignaEstiloBody(): object {
    let estBody: object = {};
    if (this.sitio == 'EasyMed') {
      estBody = { "background-image": "url('/assets/images/36918105_xl_1280x853.png')" };
    } else if (this.sitio == 'Efisys') {
      estBody = { "background-image": "url('/assets/images/tienda.png')" };
    }
    return estBody;
  }

  asignaEstiloLogo(): object {
    let estLogo: object = {};
    if (this.sitio == 'EasyMed') {
      estLogo = {};
    } else if (this.sitio == 'Efisys') {
      estLogo = { "height": "67px" };
    }
    return estLogo;
  }

  public asignaEstilo(f: FormGroup, nombre: string): object {
    return this.funcionesService.asignaEstilo(f, nombre);
  }

  public asignaEstiloSubmitDisabled(f: FormGroup): object {
    return this.funcionesService.asignaEstiloSubmitDisabled(f);
  }

  ocultaTopBar() {
    this.logService.consoleLog('2', "PC IN ocultaTopBar");
    if (
      document.getElementById("navbar-1").className.match(/navbar w-nav/)
    ) {
      document.getElementById("navbar-1").className = "navbar-oculta";
    }
  }

  ocultaFooter() {
    this.logService.consoleLog('2', "PC IN ocultaFooter");
    //document.getElementById("boton").classList.toggle("active");
    if (
      document.getElementById("footer-1").className.match(/diag-wrapper/)
    ) {
      document.getElementById("footer-1").className = "footer-oculto";
    }
  }

  muestraTopBar() {
    this.logService.consoleLog('2', "PC IN muestraTopBar");
    if (
      document.getElementById("navbar-1").className.match(/navbar-oculta/)
    ) {
      document.getElementById("navbar-1").className = "navbar w-nav";
    }
  }

  muestraFooter() {
    this.logService.consoleLog('2', "PC IN muestraFooter");
    if (
      document.getElementById("footer-1").className.match(/footer-oculto/)
    ) {
      document.getElementById("footer-1").className = "diag-wrapper";
    }
  }

  togglePwd() {
    const p = (<HTMLInputElement>document.getElementById("fTxtPwd"));
    const t = (<HTMLInputElement>document.getElementById("btnTogglePwd"));
    if (p.type === "password") {
      p.type = "text";
      t.textContent = "Ocultar";
    } else {
      p.type = "password";
      t.textContent = "Ver";
    }
  }

  cerrarMenu2() {
    if (
      document.getElementById("miMenu").className.match(/(?:^|\s)menu2(?!\S)/)
    ) {
      document.getElementById("miMenu").className = "nav-menu w-nav-menu";
    }
  }

  checkEmpresa(r: string, loginValue: firebase.auth.UserCredential) {
    this.fireEmpresaService.getFireEmpIdPref$(r)
      .pipe(take(1))
      .subscribe(eip => {
        this.fireEmpresaService.getFireEmpAut$(eip.eid)
          .pipe(take(1))
          .subscribe(emp => {
            //Detecto errores: no existe empresa o no está al día en pagos.
            //Hay otro posible error: que la base no exista, en ese caso, las rutinas del else final darán errores
            if (emp.nombre == '' || emp.nombre == undefined) {
              //no existe la empresa en tabla /empresas
              this.mensajeLogin = 'La empresa "' + r + '" no existe: ';
              this.mensajeLogin2 = 'Consulte con el administrador para solucionar el problema.';
              this.logService.consoleLog('4', 'PC IN login, empresa: ' + r + ' no existe!');
              this.muestraService.muestraMsgbox('IN-010: Atención!', this.mensajeLogin, this.mensajeLogin2, 'Aceptar', 'Warning')
                .pipe(take(1))
                .subscribe(r => {
                  this.logService.consoleLog('1', r)
                  this.muestraService.muestraLoading(false);
                  this.logout('Login incompleto');
                  return;
                });

            } else if (emp.pagosOk != 'S') {
              //empresa no está al día en pagos, el sistema no puede utilizarse
              this.mensajeLogin = 'La empresa "' + r + '" no está al día en sus pagos.';
              this.mensajeLogin2 = 'Consulte con el administrador para solucionar el problema.';
              this.logService.consoleLog('4', 'PC IN login, empresa: ' + r + ' no está al día en sus pagos');
              this.muestraService.muestraMsgbox('IN-011: Atención!', this.mensajeLogin, this.mensajeLogin2, 'Aceptar', 'Warning')
                .pipe(take(1))
                .subscribe(r => {
                  this.logService.consoleLog('1', r)
                  this.muestraService.muestraLoading(false);
                  this.logout('Login incompleto');
                  return;
                });

            } else if (this.sitio != emp.producto) {
              //por alguna razón, está entrando como Efisys a una empresa de EasyMed o viceversa
              this.mensajeLogin = 'La empresa "' + r + '" no tiene acceso al sitio ' + this.sitio + '.';
              this.mensajeLogin2 = 'Consulte con el administrador para solucionar el problema.';
              this.logService.consoleLog('4', 'PC IN login, empresa "' + r + '" no tiene acceso al sitio ' + this.sitio + '.');
              this.muestraService.muestraMsgbox('IN-015: Atención!', this.mensajeLogin, this.mensajeLogin2, 'Aceptar', 'Warning')
                .pipe(take(1))
                .subscribe(r => {
                  this.logService.consoleLog('1', r)
                  this.muestraService.muestraLoading(false);
                  this.logout('Login incompleto');
                  return;
                });

            } else {
              //Aparentemente todo OK, pero hay otro posible error: que la base no exista. 
              //Voy a usar esta llamada sencilla: getFireCfgVarias para chequear

              this.dataEmpresaService.empAutUpdate(emp);
              this.empAutElegida = this.dataEmpresaService.empAutElegida;

              this.fireConfigService.getFireCfgVarias$()
                .pipe(take(1))
                .subscribe(
                  cfgs => {
                    this.dataConfigService.cfgVariasUpdate(cfgs);
                  },
                  error => {
                    this.logService.consoleLog('4', 'PC IN login Error: ' + error.message);
                    this.mensajeLogin = 'La base de datos "' + r + '" no existe o Usted no tiene permiso para ingresar.';
                    this.mensajeLogin2 = 'Consulte con el administrador para solucionar el problema.';
                    this.logService.consoleLog('4', 'PC IN login, La base de datos de ' + r + ' no existe.');
                    this.muestraService.muestraMsgbox('IN-012: Error!', this.mensajeLogin, this.mensajeLogin2, 'Aceptar', 'Warning')
                      .pipe(take(1))
                      .subscribe(r => {
                        this.logService.consoleLog('1', r)
                        this.muestraService.muestraLoading(false);
                        this.logout('Login incompleto');
                        return;
                      });

                  }
                )


              //AQUI CHEQUEAR SI USR ESTA HABILITADO Y PERMISOS

              //Antes buscaba por: this.modeloLogin.mail, pero es más seguro por el uid
              this.fireUserService.getFireUser$(loginValue.user.uid)
                .pipe(take(1))
                .subscribe(usr => {
                  if (usr.email == undefined) {     //estaba typeof (usr.email) === 'undefined'
                    //no está creado el usr en esta empresa
                    this.logService.consoleLog('4', 'PC IN Usuario no creado en esta empresa: ' + loginValue.user.uid + ' ' + this.modeloLogin.mail);
                    this.mensajeLogin = 'Usuario no creado en esta empresa: ' + this.modeloLogin.mail;
                    this.mensajeLogin2 = 'Solicite al administrador de la empresa que se cree el usuario';
                    this.muestraService.muestraMsgbox('IN-002: Atención!', this.mensajeLogin, this.mensajeLogin2, 'Aceptar', 'Warning')
                      .pipe(take(1))
                      .subscribe(r => {
                        this.logService.consoleLog('1', r)
                        this.muestraService.muestraLoading(false);
                        this.logout('Login incompleto');
                      });
                    return;
                  }

                  //sí está creado el usr en esta empresa
                  usr.uid = loginValue.user.uid;
                  this.dataUserService.userUpdate(usr);
                  this.dataUserService.userYaCargadoUpdate(true);
                  this.logService.consoleLog('2', 'PC IN user: ' + this.dataUserService.user.uid + ' ' + this.dataUserService.user.email + ', userYaCargado: ' + (this.dataUserService.userYaCargado ? 'S' : 'N'));
                  this.modeloLogin.userYaCargado = true;
                  this.modeloLogin.mail = '';
                  this.modeloLogin.pwd = '';
                  //this.getFireProducts();
                  //this.getFireProductsCompleto();                    

                  //antes de empezar pido al árbitro que me abra una sesión
                  this.fireArbitroService.cfFireArbitro$(
                    this.modeloUsrPwd.fTxtMail,         //mail
                    'pideSesion',                       //funcion
                    '',                                 //sesion
                    '',                                 //elemento
                    '',                                 //ceja
                    '',                                 //id
                    ''                                  //bloqueo
                  )
                    .pipe(take(1))
                    .subscribe(
                      resp => {
                        if (resp.mensaje.slice(0, 8) == 'Problema' || resp.mensaje.slice(0, 6) == 'Negado') {
                          this.logService.consoleLog('9', `PC IN CF pideSesion Problema, usr ${this.modeloUsrPwd.fTxtMail}, Mensaje:  ${resp.mensaje}`);
                          this.mensajeRegistro = `No se pudo asignar sesión a ${this.modeloUsrPwd.fTxtMail} . Revise este mensaje:`;
                          this.mensajeRegistro2 = resp.mensaje;
                          this.muestraService.muestraMsgbox(`IN-013: Problema al asignar sesión`, this.mensajeRegistro, this.mensajeRegistro2, 'Aceptar', 'ThumbsUp')
                            .pipe(take(1))
                            .subscribe(r => {
                              this.logService.consoleLog('2', 'PC IN problema MsgBox: ' + r)
                              this.muestraService.muestraLoading(false);
                              this.logout('Login incompleto (sesión)');
                            });
                          return;
                        } else {
                          this.logService.consoleLog('2', `PC IN Ok CF pideSesion, mensaje:  ${resp.mensaje}`);
                          this.dataArbitroService.arbitroEstadoSesionYaCargadoUpdate(false);
                          this.dataArbitroService.arbitroSesionUpdate(resp.mensaje.slice(15));
                          this.muestraService.muestraLoading(false);

                          //Para suscribirme a .info/connected
                          this.dataSubscriptionService.onlineSuscrip = this.fireArbitroService.getFireConnected$()
                            //.pipe(take(1))      //comento el take(1) para que mantenga sincronizada la info de estado de sesión toda la sesión
                            .subscribe(online => {
                              this.logService.consoleLog('2', 'CS II online: ' + online ? 'true' : 'false');
                              this.dataArbitroService.sesionOnlineUpdate(online);
                              this.muestraService.muestraOffline(!online);
                            })

                          //Esta parte era para probar que se conectó y que tiene acceso a Firebase
                          //y servía como un log q muestra los ingresos a la base
                          //pero lo comento, ya no lo veo necesario ahora q hay la CF Arbitro q se corrió arriba
                          this.modeloUsrPwd["fFecha"] = this.fechaHoraService.formatFecha(new Date());
                          this.modeloUsrPwd["fHora"] = this.fechaHoraService.formatHora(new Date());
                          const p = this.modeloUsrPwd["fTxtPwd"];
                          //para q no se grabe el pwd en updateFireIngreso
                          this.modeloUsrPwd["fTxtPwd"] = 'xxxxxxx';
                          //const seq = this.fechaHoraService.formatFecha(new Date()) + "-" + this.fechaHoraService.formatHora(new Date());

                          //this.fireUserService
                          //  .updateFireIngreso$(seq, this.modeloUsrPwd)
                          //  .then(() => {
                          this.modeloUsrPwd["fTxtPwd"] = p;
                          this.modeloUsrPwdAnt = JSON.parse(JSON.stringify(this.formIngreso.value));
                          this.logService.consoleLog('2', "PC IN Usr y FB Ok");
                          this.formOk = true;
                          setTimeout(() => {
                            this.formOk = false;
                            if (this.dataUserService.user.tipoUsuario == 'Usuario') {
                              this.logService.consoleLog('2', 'PC IN entra al sitio-usuario');
                              this.router.navigate(['/sitio-usuario']);
                            } else {
                              if (this.dataUserService.user.tipoUsuario == 'Admin') {
                                this.logService.consoleLog('2', 'PC IN entra al sitio-admin');
                                this.router.navigate(['/sitio-admin']);
                              } else {
                                this.logService.consoleLog('4', 'PC IN login, uid: ' + loginValue.user.uid + ' no tiene tipo ');
                                this.mensajeLogin = 'Usuario no tiene tipo: ' + this.modeloLogin.mail;
                                this.mensajeLogin2 = 'Consulte con el administrador de la empresa para que se asigne un tipo';
                                this.muestraService.muestraMsgbox('IN-003: Atención!', this.mensajeLogin, this.mensajeLogin2, 'Aceptar', 'Warning')
                                  .pipe(take(1))
                                  .subscribe(r => {
                                    this.logService.consoleLog('1', r)
                                    this.muestraService.muestraLoading(false);
                                    this.logout('Login incompleto');
                                  });
                                return;
                              }
                            }
                          }, 100);
                          //})
                          /*
                          .catch(err => {
                              this.muestraService.muestraLoading(false);
        
                              this.logService.consoleLog('9', "PC IN Usr Ok, FB Error");
                              this.logService.consoleLog('9', 'PC IN Usr Ok, FB Error": ' + err.code);
                              this.logService.consoleLog('9', 'PC IN Usr Ok, FB Error": ' + err.message);
                              this.mensajeLogin = 'Error al registrar ingreso de usr: ' + this.modeloLogin.mail;
                              this.mensajeLogin2 = 'Por favor, informe este caso al administrador de la empresa';
                              this.muestraService.muestraMsgbox('IN-009: Atención!', this.mensajeLogin, this.mensajeLogin2, 'Aceptar', 'Warning')
                                .pipe(take(1))
                                .subscribe(r => {
                                  this.logService.consoleLog('1', r)
                                });
                              this.formError = true;
                              setTimeout(() => {
                                this.formError = false;
                              }, 1000);
                            });
                          */





                        }
                      },
                      err => {
                        this.logService.consoleLog('9', `PC IN CF pideSesion Error, usr ${this.modeloUsrPwd.fTxtMail}, Code:  ${err.code}`)
                        this.logService.consoleLog('9', 'PC IN CF pideSesion ' + err.code);
                        this.logService.consoleLog('9', 'PC IN CF pideSesion ' + err.message);
                        this.mensajeRegistro = `No se pudo asignar sesión a ${this.modeloUsrPwd.fTxtMail} . Revise este mensaje:`;
                        this.mensajeRegistro2 = err.message;
                        this.dataArbitroService.arbitroEstadoSesionYaCargadoUpdate(false);
                        this.muestraService.muestraMsgbox(`IN-014: Problema al asignar sesión`, this.mensajeRegistro, this.mensajeRegistro2, 'Aceptar', 'ThumbsUp')
                          .pipe(take(1))
                          .subscribe(r => {
                            this.logService.consoleLog('2', 'PC IN CF pideSesion Error: ' + r);
                            this.muestraService.muestraLoading(false);
                            this.logout('Login incompleto (sesión)');
                          });
                        return;
                      },
                      () => {
                        this.logService.consoleLog('2', 'PC IN CF pideSesion. Complete ok');
                      }
                    );

                })

            }
          })
      })
  }

  loginSubmit(btnId) {
    this.logService.consoleLog('2', 'CC IN btnId: ' + btnId);

    //pongo esto para q siempre se oculte el pwd antes de intentar ingresar, 
    //caso contrario, se puede ver por un largo tiempo
    const p = (<HTMLInputElement>document.getElementById("fTxtPwd"));
    const t = (<HTMLInputElement>document.getElementById("btnTogglePwd"));
    p.type = "password";
    t.textContent = "Ver";

    if (btnId == 'fBtnIngresar') {
      this.logService.consoleLog('2', 'CC IN Ingresar')
    } else if (btnId == 'fBtnSolicitar') {
      this.logService.consoleLog('2', 'CC IN Solicitar')
    }

    //En toda esta rutina uso return para salir cuando una condición crítica no se cumple
    //y evitar hacer una serie muy profunda de if-else anidados 

    //hay dos formas de recibir los datos del form:
    //1) creando un modelo como modeloLogin y usando two way binding para mostrar, llenar, calcular, modificar, etc.
    //   En Stroyka utilicé esta forma. 
    //2) creando un form como formIngreso, el usr lo llena y el programa lo recibe en el submit en modeloUsrPwd 
    //   En EfisysSite usé esta forma
    //En este programa no uso el modeloLogin en el html sino el formIngreso, 
    //pero uso modeloLogin para guardar variables usadas en todo el programa.
    this.mensajeLogin = '';
    this.mensajeLogin2 = '';
    this.mensajeRegistro = '';
    this.mensajeRegistro2 = '';
    this.modeloUsrPwd = JSON.parse(JSON.stringify(this.formIngreso.value));
    this.modeloLogin.mailReg = '';
    this.modeloLogin.pwdReg1 = '';
    this.modeloLogin.pwdReg2 = '';
    this.modeloLogin.mail = this.modeloUsrPwd.fTxtMail;
    this.modeloLogin.pwd = this.modeloUsrPwd.fTxtPwd;

    if (this.dataUserService.userYaCargado) {
      //no viene por aquí porque si ya ingresó ya no muestro el login
      this.logService.consoleLog('4', 'PC IN login, user ya cargado: ' + this.modeloLogin.mail);
      return;
    }

    this.logService.consoleLog('2', 'PC IN login, primera carga: ' + this.modeloLogin.mail);
    this.logService.consoleLog('2', 'PC IN mail ' + this.modeloUsrPwd.fTxtMail);
    this.modeloUsrPwdNue = JSON.parse(JSON.stringify(this.formIngreso.value));
    if (this.funcionesService.deepEqual(this.modeloUsrPwdNue, this.modeloUsrPwdAnt)) {
      this.logService.consoleLog('2', "PC IN Ya se envió esta solicitud");
      this.formDuplic = true;
      setTimeout(() => {
        this.formDuplic = false;
      }, 5000);
      return;
    }

    this.muestraService.muestraLoading(true);
    this.logService.consoleLog('2', "PC IN Primer envío");
    this.fireUserService.afLogin(this.modeloLogin.mail, this.modeloLogin.pwd)
      .then(value => {
        this.logService.consoleLog('2', 'PC IN login, uid: ' + value.user.uid + ', email verificado: ' + value.user.emailVerified);
        if (!value.user.emailVerified) {
          //Usr no ha verificado el mail, enviar nuevo email por si acaso lo ha perdido
          this.logService.consoleLog('2', 'PC IN enviando nuevo mail al usuario');
          this.mensajeLogin = 'El e-mail todavía no ha sido verificado:';
          this.mensajeLogin2 = 'En este momento le enviamos un nuevo e-mail. Abralo, dé clic en el enlace e intente ingresar nuevamente';
          this.muestraService.muestraMsgbox('IN-001: Atención!', this.mensajeLogin, this.mensajeLogin2, 'Aceptar', 'Warning')
            .pipe(take(1))
            .subscribe(r => {
              this.logService.consoleLog('1', r)
            });

          this.fireUserService.verifyMail$()
            .then(() => {
              this.logService.consoleLog('2', 'PC IN mail de verificación ok')
              this.muestraService.muestraLoading(false);
              this.logout('Login incompleto');
            })
            .catch(err => {
              this.logService.consoleLog('9', 'PC IN Error en mail de verificación')
              this.logService.consoleLog('9', 'PC IN Error en mail de verificación: ' + err.code);
              this.logService.consoleLog('9', 'PC IN Error en mail de verificación: ' + err.message);
            });
          return;
        }

        //Usr sí ha verificado el mail
        //Veo si es SuperUser
        this.fireUserService.getFireSuperUser$(value.user.uid)
          .pipe(take(1))
          .subscribe(s => {
            this.logService.consoleLog('2', 'PC IN SuperUser: ' + s ? 'true' : 'false');
            this.superUser = s;
            this.dataUserService.superUserUpdate(this.superUser);
          })
        //Sea o no SuperUser, sigo con el resto del login
        this.fireUserService.getFireUserAut$(value.user.uid)
          .pipe(take(1))
          .subscribe(userAut => {
            this.logService.consoleLog('2', 'PC IN UAcli: ' + this.dataUserService.userAut.nombre);
            userAut.uid = value.user.uid;
            this.dataUserService.userAutUpdate(userAut);
            this.logService.consoleLog('2', 'PC IN Ucli: ' + this.dataUserService.userAut.nombre);
            this.logService.consoleLog('2', 'PC IN UAaut: ' + this.dataUserService.userAut.autorizado);
            //para q pueda ver la info debe estar autorizado en usuarios/arpsa y debe haber verificado el mail.
            if (userAut.autorizado === 'S' && value.user.emailVerified) {

              const arrEmp: string[] = [];            //empresas con valor true
              let empresasMenu: string[] = [];      //empresas con valor true, pero en orden alfabético

              this.fireUserService.getFireUserEmp$(value.user.uid)
                .pipe(take(1))
                .subscribe(userEmp => {
                  if (userEmp != undefined) {
                    this.logService.consoleLog('2', 'PC IN UAcli: ' + userEmp.nombre);
                  }

                  if (userEmp == undefined || btnId == 'fBtnSolicitar') {
                    /*
                    this.muestraService.muestraLoading(false);
                    this.logService.consoleLog('4', 'PC IN login, uid: ' + value.user.uid + ' no asignado en ninguna empresa');
                    this.mensajeLogin = 'El usuario ' + this.modeloLogin.mail + ' no ha sido asignado a ninguna empresa.';
                    this.mensajeLogin2 = 'Contacte con el administrador para solicitar la asignación';
                    this.muestraService.muestraMsgbox('IN-007: Atención!', this.mensajeLogin, this.mensajeLogin2, 'Aceptar', 'Warning')
                      .pipe(take(1))
                      .subscribe(r => {
    
                      });
                    this.logout('Login incompleto');
                    return;
                    */

                    empresasMenu.push('Crear nueva empresa');
                    empresasMenu.push('Pedir acceso a una empresa');
                    this.muestraService.disableScroll();
                    //sí quiero ver los botones de Aceptar y Cancelar después de elegir: 4to parám = true
                    this.muestraService.muestraSelectbox('Elija una opción:', empresasMenu, false, true)
                      .pipe(take(1))
                      .subscribe(r => {
                        this.logService.consoleLog('2', 'PC IN Empresa elegida: ' + r);
                        if (r == 'Cancelar' || r == '') {
                          this.muestraService.muestraLoading(false);
                          this.logService.consoleLog('4', 'PC IN login, uid: ' + value.user.uid + ', empresa no seleccionada!');
                          this.logout('Login incompleto');
                          return;
                        } else if (r == 'Crear nueva empresa') {
                          this.muestraService.muestraLoading(false);
                          this.logService.consoleLog('4', 'PC IN login, uid: ' + value.user.uid + ', Crear nueva empresa!');
                          //this.logout('Crear nueva empresa');
                          this.router.navigate(['/sitio-publico/nuevaEmp']);
                          //return;
                        } else if (r == 'Pedir acceso a una empresa') {
                          this.muestraService.muestraLoading(false);
                          this.logService.consoleLog('4', 'PC IN login, uid: ' + value.user.uid + ', Pedir acceso a una empresa!');
                          //this.logout('Pedir acceso a una empresa');
                          this.router.navigate(['/sitio-publico/pedirAccesoEmp']);
                          //return;
                        }
                        this.muestraService.enableScroll();
                      });

                  }

                  //Inserto aquí la selección de empresa. En este punto se sabe ya que el usuario está registrado
                  //Leo desde la base las empresas en las que se ha registrado el usuario:
                  if (btnId == 'fBtnIngresar' && userEmp != undefined) {
                    if (userEmp.empresas != undefined) {
                      const objEmp: object = userEmp.empresas;   //variable auxiliar por facilidad
                      for (const key in objEmp) {
                        if (objEmp.hasOwnProperty(key)) {
                          this.logService.consoleLog('2', 'PC IN login, emp: ' + key + ': ' + objEmp[key]);
                          if (objEmp[key] == true) {
                            arrEmp.push(key); //solo empresas con valor true
                          }
                        }
                      }
                    }
                    if (arrEmp.length == 0) {
                      this.logService.consoleLog('4', 'PC IN login, uid: ' + value.user.uid + ' no habilitado en empresas ');
                      this.mensajeLogin = 'El usuario ' + this.modeloLogin.mail + ' no ha sido habilitado en ninguna empresa.';
                      this.mensajeLogin2 = 'Ingrese nuevamente y presione Solicitar para pedir la habilitación';
                      this.muestraService.muestraMsgbox('IN-008: Atención!', this.mensajeLogin, this.mensajeLogin2, 'Aceptar', 'Warning')
                        .pipe(take(1))
                        .subscribe(r => {
                          this.logService.consoleLog('1', r)
                          this.muestraService.muestraLoading(false);
                          //no hago logout, quiero que siga en el form de login
                          //this.logout('Login incompleto');
                        });
                      return;
                    }

                    if (arrEmp.length == 1) {
                      //si solo tiene una empresa habilitada, va allá directamente
                      this.logService.consoleLog('2', 'PC IN login, uid: ' + value.user.uid + ' solo habilitado en empresa ' + arrEmp[0]);
                      this.empAutElegidaPrefijo = arrEmp[0];
                      this.checkEmpresa(this.empAutElegidaPrefijo, value);

                    } else {
                      empresasMenu = this.funcionesService.ordenarArregloDeTextos(arrEmp, 'A');

                      this.muestraService.disableScroll();
                      //NO quiero ver los botones de Aceptar y Cancelar después de elegir: 4to parám = false
                      //quiero que se acepte directamente la opción escogida
                      this.muestraService.muestraSelectbox('Elija la empresa:', empresasMenu, false, false)
                        .pipe(take(1))
                        .subscribe(r => {
                          this.logService.consoleLog('2', 'PC IN Empresa elegida: ' + r);
                          if (r == 'Cancelar' || r == '') {
                            this.muestraService.muestraLoading(false);
                            this.logService.consoleLog('4', 'PC IN login, uid: ' + value.user.uid + ', empresa no seleccionada!');
                            this.logout('Login incompleto');
                            return;
                          }

                          this.empAutElegidaPrefijo = r;
                          this.checkEmpresa(r, value);
                          //campoBase.classList.remove("menuactivo");
                          this.muestraService.enableScroll();
                        });
                    }
                  }
                })

            } else {
              //por aquí viene solo si: a) no ha verificado el mail, o b) no está autorizado en usuarios/xxxempresaxxx
              if (!value.user.emailVerified) {
                this.logService.consoleLog('4', 'PC IN login, uid: ' + value.user.uid + ' email no verificado ');
                this.mensajeLogin = 'e-mail no verificado: ' + this.modeloLogin.mail;
                this.mensajeLogin2 = 'Cuando se registró le enviamos un e-mail con un enlace. Abralo y dé clic en el enlace para verificar que Usted es el propietario de esa dirección';
                this.muestraService.muestraMsgbox('IN-004: Atención!', this.mensajeLogin, this.mensajeLogin2, 'Aceptar', 'Warning')
                  .pipe(take(1))
                  .subscribe(r => {
                    this.logService.consoleLog('1', r);
                    this.muestraService.muestraLoading(false);
                    //no hago logout, quiero que siga en el form de login
                    //this.logout('Login incompleto');
                  });
              } else {
                this.logService.consoleLog('4', 'PC IN login, uid: ' + value.user.uid + ' no autorizado ');
                this.mensajeLogin = 'Usuario no autorizado: ' + this.modeloLogin.mail;
                this.mensajeLogin2 = 'Consulte con su administrador para solicitar autorización';
                this.muestraService.muestraMsgbox('IN-005: Atención!', this.mensajeLogin, this.mensajeLogin2, 'Aceptar', 'Warning')
                  .pipe(take(1))
                  .subscribe(r => {
                    this.logService.consoleLog('1', r)
                    this.muestraService.muestraLoading(false);
                    //no hago logout, quiero que siga en el form de login
                    //this.logout('Login incompleto');
                  });
              }
            }
          })

      })
      .catch(err => {
        this.mensajeLogin = 'Error en el ingreso';
        this.logService.consoleLog('9', 'PC IN Error en el ingreso: ' + err.code);
        this.logService.consoleLog('9', 'PC IN Error en el ingreso: ' + err.message);
        switch (err.code) {
          case 'auth/invalid-email':
            this.mensajeLogin2 = 'El e-mail no es válido, por favor revísalo.';
            break;
          case 'auth/user-disabled':
            this.mensajeLogin2 = 'El usuario está inhabilitado, por favor comuníquese con el administrador de la empresa';
            break;
          case 'auth/user-not-found':
            this.mensajeLogin2 = 'Este usuario no existe, quizás está mal digitado o aún no se ha registrado.';
            break;
          case 'auth/wrong-password':
            this.mensajeLogin2 = 'La contraseña es incorrecta, por favor digítela nuevamente.';
            break;
          case "auth/network-request-failed":
            this.mensajeLogin2 = 'Error de red: timeout, no se puede contactar el host, no hay Internet, etc.';
            break;
          default:
            this.mensajeLogin2 = 'Error en login. Code: ' + err.code + ';  Message: ' + err.message.slice(0, 600);
            break;
        }
        this.muestraService.muestraMsgbox('IN-006: Error en el ingreso!', this.mensajeLogin, this.mensajeLogin2, 'Salir', 'Error')
          .pipe(take(1))
          .subscribe(r => {
            this.logService.consoleLog('1', r)
            this.muestraService.muestraLoading(false);
            //no hago logout, quiero que siga en el form de login
            //this.logout('Login incompleto');
          });
      });
    return;
  }

  logout(msg: string) {
    this.fireUserService.afLogout()
      .then(() => {
        this.logService.consoleLog('4', 'PC IN ' + msg + ', logout ok');
        //alert('Servicio de usuarios de Efisys: salida exitosa');
        this.dataUserService.userAutUpdate(userAutVacio);
        this.dataUserService.userUpdate(userVacio);
        this.dataUserService.userYaCargadoUpdate(false);
        this.router.navigate(['/sitio-publico']);
      })
      .catch(err => {
        this.logService.consoleLog('9', 'PC IN ' + msg + ', logout error');
        this.logService.consoleLog('9', 'PC IN Logout error: ' + err.code);
        this.logService.consoleLog('9', 'PC IN Logout error: ' + err.message);
        this.router.navigate(['/sitio-publico']);
      });
    return;
  }
}
